import { useContext } from "react";
import themeContext from "../../themeContext/themeContext";
import "./styledComponents";

import {
  AboutSectionContainer,
  AboutContainer,
  Photowrapper,
  MyPhoto,
  Background,
  BackgroundTitle,
  BackgroundSubtile,
  Description,
  TechStackContainer,
  TechStackHeading,
  Tools,
  ToolList,
  ToolItem,
} from "./styledComponents";

function AboutSection() {
  const { isDarkMode } = useContext(themeContext);
  return (
    <AboutSectionContainer id="about">
      <AboutContainer>
        <Photowrapper>
          <MyPhoto
            alt="my photo"
            loading="lazy"
            src="https://res.cloudinary.com/dhzqndogf/image/upload/v1716280164/Achivers_new_images_lsjscw.png"
          />
        </Photowrapper>
        <Background isDarkMode={isDarkMode}>
          <BackgroundTitle>Achievers Club</BackgroundTitle>
          <BackgroundSubtile>A bit About Achievers Club</BackgroundSubtile>
          <Description>
            Our organization is called Achievers Clubs, an innovative Indian
            startup proudly associated with the Digital India flagship program.
            Achievers Clubs is dedicated to empowering individuals through
            cutting-edge digital solutions and training, driving progress and
            innovation in the digital landscape of India.
          </Description>
          <Description>
            We're working on Digital Project which is associated with Govt.
            Digital India Model.
          </Description>

          <Description>
            Digital India Project is a flagship programme of the Government of
            India with a vision to transform India into a digitally empowered
            society and knowledge economy. The programme was launched on July 1,
            2015
          </Description>
          <Description>
            <TechStackContainer isDarkMode={isDarkMode}>
              <TechStackHeading>Skill Hub</TechStackHeading>
              <Tools>
                <ToolList>
                  <ToolItem>Communication Skills</ToolItem>
                  <ToolItem>Networking</ToolItem>
                  <ToolItem>Negotiation</ToolItem>
                </ToolList>
                <ToolList>
                  <ToolItem>Problem-solving</ToolItem>
                  <ToolItem>Time management</ToolItem>
                  <ToolItem>Adaptability</ToolItem>
                </ToolList>
                <ToolList>
                  <ToolItem>Salesmanship</ToolItem>
                  <ToolItem>Analytical thinking</ToolItem>
                  <ToolItem>Relationship building</ToolItem>
                </ToolList>
                <ToolList>
                  <ToolItem>Industry knowledge</ToolItem>
                  <ToolItem>Multi Lingual</ToolItem>
                </ToolList>
              </Tools>
            </TechStackContainer>
          </Description>
        </Background>
      </AboutContainer>
    </AboutSectionContainer>
  );
}

export default AboutSection;
